import { baseApi } from '../baseApi';
import { EvaluationModel } from '../../models/evaluationModel';
import { cleanObject } from '../../utils/objectUtils';

export enum EvaluationCtx {
  EVALUATOR = 'evaluator',
  SUBJECT = 'subject',
}

export async function getEvaluationsListReq(evaluationCtx: EvaluationCtx, forPersonId?: string) {
  let url = '/officiating/evaluation?';
  if (forPersonId) url = '/officiating/evaluation/other?';

  let queryParamsObj = cleanObject({
    mode: evaluationCtx,
    personId: forPersonId,
  });

  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.get<EvaluationModel[]>(url + queryParams);
}
